import { Paragraph } from '@zillow/constellation-10';
import React, { useContext } from 'react';
import StringConstants from '../../../../constants/StringConstants';
import { InboxPageContext } from '../../../../contexts/InboxPageContextProvider';
import { useConversationMessagesQuery } from '../../../../hooks/useConversationMessagesQuery';
import type { ConversationMessagesData } from '../../../../utils/conversationMessageUtils';
import InboxSidebarSection from '../InboxSidebarSection';
import InviteToApply from '../InviteToApply';
import { useAuth } from '../../../../AuthProvider';

export type NextStepData = {
  isPhoneLead: boolean;
  isApplicationsAllowed: boolean;
  renterEmail: string;
};

export const selectNextStepData = (data: ConversationMessagesData): NextStepData => ({
  isPhoneLead: data.isPhoneLead,
  isApplicationsAllowed: data.isApplicationsAllowed,
  renterEmail: data.renterEmail ?? '',
});

export default function NextStep(): JSX.Element | null {
  const { conversationId, clientTimeZone } = useContext(InboxPageContext);
  const { user } = useAuth();
  // Cache-only read — `MessageListItems` owns the `getMessages` fetch + polling.
  const { data: nextStepData } = useConversationMessagesQuery({
    conversationId,
    clientTimeZone,
    enabled: false,
    select: selectNextStepData,
  });

  if (!nextStepData) {
    return null;
  }

  const { isPhoneLead, isApplicationsAllowed, renterEmail } = nextStepData;

  if (isPhoneLead) {
    return (
      <InboxSidebarSection title="Next step">
        <Paragraph>{StringConstants.TOOLTIP.PHONE_LEAD}</Paragraph>
      </InboxSidebarSection>
    );
  }

  if (isApplicationsAllowed && !user?.isMultifamilyCustomer && renterEmail) {
    return <InviteToApply />;
  }

  return null;
}
